module.exports = __webpack_public_path__ + "img/rotate.2865d0bd.png";